const quickLinks = [
	{
		link: "about",
		text: "About us",
	},
	{
		link: "contact",
		text: "Contact",
	},
	{
		link: "privacy",
		text: "Privacy policy",
	},
	{
		link: "sitemap",
		text: "Sitemap",
	},
	{
		link: "tos",
		text: "Terms of Use",
	},
];

export default quickLinks;
